import { forwardRef } from 'react';

import { NotifyPeopleModalRoot } from 'hb-react/frontoffice/components/NotifyPeopleModal';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import type { UserTargetingProps } from './types';
import UserTargetingLegacy from './UserTargeting';

// No need for the forwardRef when flagHivehackNotifyPeople is removed
// The openByClickOn prop can also be removed when flagHivehackNotifyPeople is removed (replaced by renderTriggerElement)
const UserTargeting = forwardRef<UserTargetingLegacy, UserTargetingProps>(
  ({ defaultSelectedUsers, ...props }, ref) => {
    const { flagHivehackNotifyPeople } = useFeatureFlag();

    if (flagHivehackNotifyPeople) {
      // We only need defaultSelectedUsers for the new version of the component
      return (
        <NotifyPeopleModalRoot
          defaultSelectedUsers={defaultSelectedUsers}
          {...props}
        />
      );
    }

    return <UserTargetingLegacy ref={ref} {...props} />;
  },
);

export default UserTargeting;
